import React from 'react';
import TTLProxy from "../TTLAsyncProxy";
import Settings from "./settings.json";
import AppGlobal from '../../common/AppGlobals';
import Utils, {isCRUDView} from "../Utils";
import CheckOptionView from '../CheckOptionView/CheckOptionView';
import PropTypes from 'prop-types';
import MobileDetect from "mobile-detect";
import QueryString from 'query-string';
import history from '../../history';
import {createQuery, joinQuery} from "../../components/FilterQueryWrapper/FilterQueryWrapper";
import {getActiveView} from "../ActiveView";
import {handleBrowserUnload} from "../Events/EventSource";

const Styles = {

    selectOption:{
        borderRadius: 2,
        padding: 2,
    }

};

const InvalidateCaches = [
    "tractor_owners",
    "fbo",
    "operators",
    "tractor_requests",
    "tractors",
    "transactions",
    "users",
    "farmers"
];

function setSetting(key , value, saveImmediately = false) {

    const proxy = TTLProxy.getInstance();
    const user = proxy.getUserInfo();
    let sett =  AppGlobal.get("settings");

    if(sett){
        sett[key] = value;
        AppGlobal.set("settings",value);
    }

    if(saveImmediately){
        LocalSettingsManager.save(user.id,sett);
    }
}

function getSetting(key , defaultValue) {

    const proxy = TTLProxy.getInstance();
    const user = proxy.getUserInfo();
    let sett =  AppGlobal.get("settings");

    if(!sett){
        sett = LocalSettingsManager.get(user.id) ;
        AppGlobal.set("settings", sett );
    }

    if(sett && sett.hasOwnProperty(key)){
        return sett[key];
    }

    const option = Settings[user.role].find(x => x.key == key);
    if(!option){

        if(typeof defaultValue == "function")
            return defaultValue();
        else if(defaultValue){
            return defaultValue;
        }
    }

    if(typeof option.default == "object" && (option.default.hasOwnProperty("mobile") ||  option.default.hasOwnProperty("desktop") ) ){

        const dv = option.default;
        if((new MobileDetect(window.navigator.userAgent)).mobile()){
            return dv.mobile;
        }
        else{
            return dv.desktop;
        }
    }
    else{
        return option.default;
    }

}

class LocalSettingsManager {

    static USERDATA_KEY = '__ttl_users_state';

    static __getAll(){

        let value = window.localStorage.getItem(LocalSettingsManager.USERDATA_KEY);
        if(!value){

            value = { users: []};
            window.localStorage.setItem(LocalSettingsManager.USERDATA_KEY, JSON.stringify(value) );
        }
        else{
            value =  JSON.parse(value);
        }

        return value;
    }

    /**
     * Retrieve settings for user with the given id
     * @param id The id of the user
     */
    static get(id){

        const payload = LocalSettingsManager.__getAll();
        const frame = payload.users.find(x => x.id == id);
        if(frame){
            return frame.data;
        }
        else {

            const proxy = TTLProxy.getInstance();
            const userInfo = proxy.getUserInfo();

            let data = { };

            if(userInfo) {

                const frame = Settings[userInfo.role];
                for (let i = 0, len = frame.length; i < len; i++) {

                    const f = frame[i];
                    if(typeof f.default == "object" ) {

                        if((new MobileDetect(window.navigator.userAgent)).mobile()){
                            data[f.key] = f.default.mobile;
                        }
                        else{
                            data[f.key] = f.default.desktop;
                        }

                    }
                    else{
                        data[f.key] = f.default;
                    }

                }

            }

            //  add user frame
            const frameData = {
                id: id,
                data: data
            };

            payload.users.push(frameData);
            window.localStorage.setItem(LocalSettingsManager.USERDATA_KEY,JSON.stringify(payload));

            return frameData.data;
        }
    }

    /**
     * Save setting for user with the given id
     * @param id The id of the user
     * @param data The data associated with the user
     */
    static save(id,data){

        const payload = LocalSettingsManager.__getAll();
        const frame = payload.users.find(x => x.id == id);
        if(frame){
            frame.data = data;
        }
        else{

            const frameData = {
                id: id,
                data: data
            };

            payload.users.push(frameData);
        }

        window.localStorage.setItem(LocalSettingsManager.USERDATA_KEY,JSON.stringify(payload));
    }

}



class SettingsView extends React.Component{

    proxy = TTLProxy.getInstance();

    static propTypes = {
       type: PropTypes.string
    };

    static defaultProps = {
       type: 'aside'
    };

    constructor(props){
        super(props);

        const user = this.proxy.getUserInfo();
        const role = user.role;

        this.state = {
            role: role,
            options: Settings[role],
            userId: user.id,
            userSettings: AppGlobal.get('settings') || LocalSettingsManager.get(user.id)
        };

    }

    /**
     * Save user settings to store
     */
    persistSettings(){
        LocalSettingsManager.save(this.state.userId , this.state.userSettings);
    }

    componentDidMount(){

        const me = this;
        handleBrowserUnload((location) => {
            me.persistSettings()
        });
    }

    componentWillUnmount(){
        this.persistSettings();
    }

    static invalidateCache(){
        Utils.eraseSession(InvalidateCaches);
    }

    getValue(key){

        if(this.state.userSettings.hasOwnProperty(key)){
            return this.state.userSettings[key];
        }else{

            //  find default value
            const option = this.state.options.find(x => x.key == key);
            if(option){

                if(typeof option.default == "object" && (option.default.hasOwnProperty("mobile") ||  option.default.hasOwnProperty("desktop") ) ){

                    const dv = option.default;
                    if(AppGlobal.get('isMobile')){
                        return dv.mobile;
                    }
                    else{
                        return dv.desktop;
                    }
                }
                else{
                    return option.default;
                }

            }

        }
    }

    setValue(key,value){

        let settings = this.state.userSettings;
        settings[key] = value;

        this.setState({
            userSettings: settings
        });

        //  update global settings
        AppGlobal.set('settings', settings)
    }

    render(){

        const options = this.state.options;
        let content;
        switch (this.props.type){
            case 'aside': {

                content = options.map((x,index) => {

                    switch(x.type){

                        case 'check':
                           return <CheckOptionView key={index} optionKey={x.key} value={this.getValue(x.key)} title={x.title} hint={x.hint} onChange={checked => {

                               //   save input to store
                               this.setValue(x.key,checked);

                           }}/>;
                        case "select":
                            return (<div key={index} className="mt-4">
                                        <small><b>{x.title}</b></small>
                                        {x.hint && <div>
                                            <small className="text-muted">{x.hint}</small>
                                        </div>}
                                        <select value={this.getValue(x.key)} onChange={(evt) => {

                                            const value = evt.target.value;
                                            this.setValue(x.key,value);

                                            if(x.invalidate){
                                                SettingsView.invalidateCache();
                                            }

                                            switch(x.action){

                                                case "update_query":{

                                                    const key = x.query_key;
                                                    const query = QueryString.parse(history.location.search);

                                                    const activeView = getActiveView();
                                                    if(activeView && isCRUDView(activeView)){

                                                        history.push( joinQuery(history.location.pathname, createQuery({
                                                            ...query,
                                                            [key]: value
                                                        })));

                                                    }




                                                }
                                            }



                                        }} style={Styles.selectOption}>
                                        {x.items.map((m,index) => {
                                            return <option key={index}>{m}</option>
                                        })}
                                        </select>
                                    </div>)
                    }

                });

            }break;
            case 'form':{


            }break;
        }

        return <div>{content}</div>;
    }
}

export {
    LocalSettingsManager,
    SettingsView,
    getSetting,
    setSetting
};


// WEBPACK FOOTER //
// ./src/common/LocalSettings/LocalSettings.js